<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Document" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-document-form [document]="document" *ngIf="document"></app-document-form>
        </form>
      </div>
    </section>
  </div>
</div>
